import request from "@utils/petRequest";

const PetApi = {};

PetApi.userInfo = (data) => {
	return request.post("/petAdmin/userInfo", data, { login: true });
}

PetApi.petIncomeList = (data) => {
	return request.post("/petAdmin/income/list", data, { login: true });
}

PetApi.petDeviceList = (data) => {
	return request.post("/petAdmin/deviceList", data, { login: true });
}

PetApi.petDeviceRepairsList = (data) => {
	return request.post("/petAdmin/repairsList", data, { login: true });
}

PetApi.petDeviceFaultList = (data) => {
	return request.post("/petAdmin/faultList", data, { login: true });
}

PetApi.petApplyFault = (data) => {
	return request.post("/petAdmin/applyFault", data, { login: true });
}

PetApi.petDeviceInfo = (sn,data) => {
	return request.get("/petAdmin/deviceInfo/" + sn, data || {}, { login: true });
}

PetApi.petDeviceConfigInfo = (sn,data) => {
	return request.get("/petAdmin/configInfo/" + sn, data || {}, { login: true });
}

PetApi.petDeviceStockConfig = (data) => {
	return request.post("/petAdmin/stockConfig", data, { login: true });
}

PetApi.petDeviceDoSth = (data) => {
	return request.post("/petAdmin/deviceDoSth", data, { login: true });
}

PetApi.petPriceGet = (sn,data) => {
	return request.get("/petAdmin/priceGet/" + sn, data || {}, { login: true });
}

PetApi.petPriceSave = (data) => {
	return request.post("/petAdmin/priceSave", data || {}, { login: true });
}

PetApi.petDeviceInfoSave = (data) => {
	return request.post("/petAdmin/deviceInfoSave", data || {}, { login: true });
}

PetApi.petOrderList = (data) => {
	return request.post("/petAdmin/orderList", data, { login: true });
}

PetApi.petIncomeList = (data) => {
	return request.post("/petAdmin/incomeList", data, { login: true });
}

PetApi.petMaterialList = (data) => {
	return request.post("/petAdmin/materialList", data, { login: true });
}

PetApi.petIncomeBadge = (data) => {
	return request.post("/petAdmin/incomeBadge", data, { login: true });
}

PetApi.petSettlement = (data) => {
	return request.get("/petAdmin/settlement", data || {}, { login: true });
}

PetApi.petApplySettlement = (data) => {
	return request.post("/petAdmin/applySettlement", data || {}, { login: true });
}

PetApi.petSettlementList = (data) => {
	return request.post("/petAdmin/settlementList", data || {}, { login: true });
}

PetApi.petSettlementDetail = (data) => {
	return request.post("/petAdmin/settlementDetail", data || {}, { login: true });
}

PetApi.petNoticeList = (data) => {
	return request.post("/petAdmin/notice", data || {}, { login: true });
}

PetApi.petSetBankCard = (data) => {
	return request.post("/petAdmin/setBankCard", data || {}, { login: true });
}
PetApi.petBankCard = (data) => {
	return request.post("/petAdmin/bankCard", data || {}, { login: true });
}

PetApi.login = (data) => {
	return request.post("/petAdmin/login", data, { login: false });
}

PetApi.logout = (data) => {
	return request.get("/petAdmin/logout", data || {}, { login: true });
}

PetApi.petTemperatureGet = (sn,data) => {
	return request.get("/petAdmin/temperatureGet/" + sn, data || {}, { login: true });
}

PetApi.petTemperatureSave = (data) => {
	return request.post("/petAdmin/temperatureSave", data || {}, { login: true });
}

export default PetApi;